import { setByPath } from '@the-platform-company/path-utilities'
import { deepEqual } from 'fast-equals'
import { useEffect, useState } from 'react'

const originalSetItem = localStorage.setItem
// This is a hack that enables listening for local storage changes in the same window
localStorage.setItem = (key: string, value: string) => {
  document.dispatchEvent(new Event('__rbtn_storage'))
  return originalSetItem.apply(localStorage, [key, value])
}
const tryParse = (value: string) => {
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}
const parseStorage = (storage: Storage) =>
  Object.keys(storage)
    .filter((k) => k !== 'setItem')
    .reduce(
      (acc, k) => setByPath(acc, k, tryParse(storage.getItem(k) ?? 'null')),
      {}
    )

export const useLocalStorage = () => {
  const [localStorageState, setLocalStorageState] = useState(() =>
    parseStorage(localStorage)
  )

  useEffect(() => {
    const listener = () => {
      setTimeout(() => {
        const nextLocalStorageState = parseStorage(localStorage)

        setLocalStorageState((prevLocalStorageState) =>
          deepEqual(nextLocalStorageState, prevLocalStorageState)
            ? prevLocalStorageState
            : nextLocalStorageState
        )
      }, 0)
    }

    document.addEventListener('__rbtn_storage', listener)
    window.addEventListener('storage', listener)

    return () => {
      document.removeEventListener('__rbtn_storage', listener)
      window.removeEventListener('storage', listener)
    }
  }, [setLocalStorageState])

  return localStorageState
}
